import CharacterBadgeButton from 'components/common/Buttons/CharacterBadgeButton';
import makeStyles from '@mui/styles/makeStyles';
import type { Assignment } from '@monorepo/shared/src/graph/schema-generated-types-student';
import { AppRoutes } from '@monorepo/shared/src/types';
import { getAllLettersWithAssignments } from '../../utils/reports-utils';
import { isCompletedStatus } from 'components/modules/Assignments/util';

type Props = {
  assignments: Assignment[];
};

const LetterProgress: React.FC<Props> = ({ assignments }) => {
  const classes = useStyles();
  const isCharacterCompleted = (assignment) => isCompletedStatus(assignment.status);
  const isDisabled = (assignment) => !assignment.assigned;
  const allLetters = getAllLettersWithAssignments(assignments);

  return (
    <div className={classes.lettersContainer}>
      {allLetters?.map((assignment, idx) => {
        return (
          <CharacterBadgeButton
            key={idx}
            redirectRoute={{
              path: `/reports/${assignment.character.character}`,
              title: AppRoutes.REPORTS,
            }}
            character={`${assignment.character.character}`}
            showCheckIcon={isCharacterCompleted(assignment)}
            disabled={isDisabled(assignment)}
          />
        );
      })}
    </div>
  );
};

export default LetterProgress;

const useStyles = makeStyles((theme) => ({
  lettersContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gridGap: theme.typography.pxToRem(20),
  },
}));
